import React, { memo } from "react";
import styles from "./TabSelector.module.scss";

export type Tab = {
	id: number;
	title: string;
	icon?: React.ReactNode;
	onClick: () => void;
};

type Props = {
	tabs: Tab[];
	selectedTab: number;
	theme?: string;
};

const TabSelector: React.FC<Props> = memo((props: Props) => {
	const { tabs, selectedTab, theme } = props;

	return (
		<div className={`${styles.container} ${theme ? styles[theme] : ""} `}>
			{tabs.map((tab, index) => (
				<button key={tab.id} className={`standardButton ${styles.tab} ${tab.id === selectedTab ? styles.tabSelected : ""}`} onClick={tab.onClick}>
					{tab.icon}
					{tab.title}
				</button>
			))}
		</div>
	);
});

export default TabSelector;
